var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgExtrudeUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "2 -19 44 43",
    width: 28,
    height: 27,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("marker", {
    orient: "auto",
    overflow: "visible",
    markerUnits: "strokeWidth",
    id: "prefix__a",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    viewBox: "-1 -2 5 4",
    markerWidth: 5,
    markerHeight: 4,
    color: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.4 0L0-.9V.9z",
    fill: "currentColor",
    stroke: "currentColor"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    markerEnd: "url(#prefix__a)",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M42 5.153V-9.9"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 3,
    d: "M3.944 11.193L22.492 22M41 11.193L22.452 22M3.964 11.193l3.789-2.242M41 11.193l-3.789-2.242"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.338 8.154V-4.154a3.077 3.077 0 00-1.539-2.661L24.03-12.97a3.077 3.077 0 00-3.077 0L10.184-6.815a3.077 3.077 0 00-1.538 2.661V8.154a3.077 3.077 0 001.538 2.661l10.77 6.154c.951.55 2.124.55 3.076 0l10.77-6.154a3.077 3.077 0 001.538-2.661z",
    stroke: "#00c",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.061-5.754l13.43 7.77 13.432-7.77M22.492 17.508V2",
    stroke: "#00c",
    strokeWidth: 3
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExtrudeUp);
export default __webpack_public_path__ + "static/media/ExtrudeUp.1c16c4ae0a927a65bb882fd531bee101.svg";
export { ForwardRef as ReactComponent };